//const sendgridMailer = require("@sendgrid/mail");
//const client = require('@sendgrid/client');
//client.setApiKey("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");
const url = "https://api.sendgrid.com/v3/marketing/contacts"
const apiKey = "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"

export async function liveQaSignup(email, listId, eventTitle, eventDate){    
    try{
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${apiKey}`);
        myHeaders.append("Content-Type", "application/json");

        const data = JSON.stringify({
            "list_ids": [
                listId
            ],
            "contacts": [
                {
                    "email": email,
                    "custom_fields": {
                        "w2_T":eventTitle, //id of custom event definition in sendgrid
                        "w3_D":eventDate
                    }
                }
            ]
        })

        const request = {
            method: 'PUT',
            headers: myHeaders,
            body: data
        }
        
        const res = await fetch(url, request)
        console.log(res.status)
        return res.status;
    } catch(err) {
        console.log(err)
    }
} 

